import { gql } from "@apollo/client";

import { CALL_PLAN_DETAIL } from "@/graphql-client/fragments";

export const REMOVE_INTERACTIONS_MUTATION = gql`
  mutation RemoveInteractions($input: RemoveInteractionsInput!) {
    removeInteractions(input: $input) {
      ...CallPlanDetail
    }
  }
  ${CALL_PLAN_DETAIL}
`;

export const DEACTIVATE_CALL_PLAN_MUTATION = gql`
  mutation DeactivateCallPlan($id: Int!) {
    deactivateCallPlan(id: $id)
  }
`;

export const REACTIVATE_CALL_PLAN_MUTATION = gql`
  mutation ReactivateCallPlan($id: Int!) {
    reactivateCallPlan(id: $id)
  }
`;
